"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _has2 = _interopRequireDefault(require("lodash/has"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(field) {
  var validationSettings = field.validationSettings,
    type = field.type,
    displaySettings = field.displaySettings;
  var initialValue;
  if ((displaySettings.renderAs === 'select' || displaySettings.renderAs === 'enum') && displaySettings.selectionType === 'multi') {
    return [];
  }
  if (type === 'pawnField' || 'coalesceKey' in field && (field.coalesceKey === 'parentPawns' || field.coalesceKey === 'childPawns')) {
    if (displaySettings.fieldProps && displaySettings.fieldProps.setValueNotArray) {
      return '';
    }
    if (displaySettings.renderAs === 'select') {
      return 'allowSendNull' in field ? null : undefined;
    }
    return [];
  }
  if (displaySettings.renderAs === 'assignmentPlans') {
    return [];
  }
  if (['checkbox', 'toggle'].includes(displaySettings.renderAs)) {
    if (displaySettings.fieldProps && 'initialValue' in displaySettings.fieldProps) {
      return displaySettings.fieldProps.initialValue;
    }
    return false;
  }
  if (displaySettings.renderAs === 'enum') {
    return null;
  }
  if (displaySettings.renderAs === 'instructionalText') {
    return undefined;
  }
  if ('validationSettings' in field && 'validationType' in field.validationSettings) {
    switch (validationSettings.validationType) {
      case 'alphanumeric':
      case 'ascii':
      case 'phoneNumber':
      case 'email':
        initialValue = '';
        break;
      case 'integer':
        initialValue = 0;
        break;
      case 'decimal':
        initialValue = 0.0;
        break;
      case 'date':
      case 'dateTime':
        if ((0, _has2["default"])(displaySettings, 'emptyValue')) {
          initialValue = '';
          break;
        }
        initialValue = new Date();
        break;
      default:
        initialValue = '';
        break;
    }
  } else {
    initialValue = '';
  }
  return initialValue;
};